import React from 'react';
import { useNavigate, Link } from "react-router-dom";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { IoPersonSharp } from "react-icons/io5";
import axiosPublic from "../../services/axios/axiosPublic";
import api from "../../services/api";
import { useForm } from 'react-hook-form';

export default function ForgotPassword() {
    const navigate = useNavigate();
    const {
        register,
        handleSubmit,
        formState: { errors },
        reset, clearErrors, setValue
    } = useForm();
    const token = localStorage.getItem("token");
    if (token) {
        navigate("/admin/dashboard");
    }
    const emailRegex = /^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    const handleFormSubmit = async (data) => {
        const emailForPasswordReset = data.emailForPasswordReset;
        if (!emailRegex.test(data.emailForPasswordReset)) {
            return;
        }
        try {
            const formData = new URLSearchParams();
            formData.append("email", emailForPasswordReset);
            const response = await axiosPublic.post(api.forgotpassword, formData);
            if (response?.data?.success === true) {
                toast.success(response?.data?.reason, {
                    className: "toast-success-custom",
                });
                reset({ emailForPasswordReset: "" });
                setTimeout(() => {
                    navigate("/");
                }, 2000);
            } else {
                toast.error(response?.data?.reason, {
                    className: "toast-error-custom",
                    autoClose: 8000,
                });
                reset({ emailForPasswordReset: "" });
            }
        } catch (error) {
            toast.error(
                error?.data?.reason || "Unable to connect to server",
                { className: "toast-error-custom", autoClose: 8000 }
            );
        }
    };

    return (
        <div className="container-fluid container-fluid-login">
            {/* logo header part */}
            <div className='main-logo'>
                <div className="logo-image">
                    <img src={require("assets/img/company_logo.png")} alt="..." />
                </div>
            </div>
            <div className="login-container">
                <div className="login-row">
                    <div className="col-lg-12 col-md-10 col-sm-8 col-xs-12 left login-row-inner">
                        <div className="login-form">
                            <div className="title" style={{ marginBottom: '10px' }}>
                                <p className="welcome" style={{ marginBottom: '3px' }}>Forgot Password</p>
                                <p className="forgot-title" style={{ color: '#5A5A5A', marginTop: '0', fontSize: '14px' }}>{"Enter your email and we'll send you a link to reset your password."}</p>
                            </div>
                            <div className="form">
                                <form onSubmit={handleSubmit(handleFormSubmit)}>
                                    <div className="form-detail">
                                        <div className={`input-text ${errors.emailForPasswordReset ? 'error' : ''}`}>
                                            <div className="input-icons">
                                                <IoPersonSharp className="icon" />
                                                <input className="login-input-field" type="email" placeholder="Enter email id"
                                                    {...register("emailForPasswordReset", {
                                                        pattern: {
                                                            value: emailRegex,
                                                            message: "Please enter a valid email address",
                                                        }, required: "Email is required for reset password link"
                                                    })}
                                                    onChange={(e) => {
                                                        setValue("emailForPasswordReset", e.target.value);
                                                        clearErrors("emailForPasswordReset");
                                                    }} />
                                                {errors.emailForPasswordReset && (
                                                    <p className="error-message">{errors.emailForPasswordReset.message}</p>)}
                                            </div>
                                        </div>
                                        <div>
                                            <div>
                                                <button className="login" type="submit">
                                                    Request Reset Link
                                                </button>
                                            </div>
                                            <div className='backtologin'>
                                                <button className="backtologin-btn" type="button">
                                                    <Link className='bk' to={'/'}>Back To Login</Link>
                                                </button>
                                            </div>
                                        </div>
                                        <br />
                                        <ToastContainer />
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
